import EquipmentModelsMultiSelect from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelsMultiSelect'
import css from './equipmentFilterModels.module.css'
import { IEquipmentModel } from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.types'

interface IProps {
  models: IEquipmentModel['id'][]
  onChange: (modelIds: IEquipmentModel['id'][], name: string) => void
  name?: string
}

const EquipmentFilterModels = (props: IProps) => {
  return (
    <div className={css.wrapper}>
      <EquipmentModelsMultiSelect
        name={props.name}
        onSelect={props.onChange}
        selected={props.models}
        panelStyle={{ width: '230px' }}
        title="Модели"
        type="filter"
      />
    </div>
  )
}

export default EquipmentFilterModels
